import React from 'react'

import clsx from 'clsx'

import { Container } from 'components/Grid'
import Icon from 'components/Icon'
import { useEventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import Tab from './components/Tab'
import TabsRoot from './components/TabsRoot'
import { tabIcons } from './constants'

import classes from './Navigation.module.scss'

const NOOP = () => {}

const EVENT_ACTION_DICTIONARY = {
  serp_category: 'category_all-products',
  serp_category_leaders: 'category_leaders',
}

const getEngagementDestination = ({ slug, route_name }) => {
  if (slug === 'guide') {
    return `jump-to_${EVENT_ACTION_DICTIONARY.serp_category}_guide`
  }

  return `go-to_${EVENT_ACTION_DICTIONARY[route_name] || route_name}`
}

/** @type {import("./types").default} */
const Navigation = ({
  className,
  navTabs = [],
  onTabClick = NOOP,
  selectedTab,
  onReadMore = NOOP,
  expandFeaturesContent = false,
  hasFeaturesContent = false,
}) => {
  const { up } = useViewport()
  const isDesktop = up('lg')

  const { addEvent } = useEventContext({
    engagementComponent: 'navigation-bar',
    name: 'engagement_navigation',
  })

  const handleChange = (event, newValue) => {
    onTabClick(newValue)
  }

  const NavigationWrapper = isDesktop ? Container : 'div'
  const featuresContentTab = {
    label: expandFeaturesContent ? 'Read less' : 'Read more',
    icon: expandFeaturesContent ? 'minus' : 'plus',
    slug: 'features-content',
  }

  return (
    <NavigationWrapper className={clsx('Tabs', classes.root, className)}>
      <div className={clsx(classes.fade, classes.fadeLeft)} />
      <div className={classes.tabsRow}>
        <TabsRoot value={selectedTab} onChange={handleChange} className={classes.hideScroll}>
          {hasFeaturesContent && (
            <Tab
              onClick={onReadMore}
              icon={<Icon prefix="far" icon={featuresContentTab.icon} />}
              key={featuresContentTab.label}
              className={classes.readMoreBtn}
              label={<span className={classes.label}>{featuresContentTab.label}</span>}
              target="_self"
              value={featuresContentTab.slug}
              {...addEvent({
                engagementComponent: 'navigation-bar',
                engagementDestination: expandFeaturesContent ? 'collapse-content' : 'expand-content',
                engagementDetails: 'navigation-tab',
                name: 'engagement_product_click',
              })}
            />
          )}

          {navTabs.map(tab => (
            <Tab
              aria-label={tab.route_name}
              aria-selected={selectedTab === tab.slug}
              component="a"
              data-testid={`tab-${tab.route_name}`}
              href={tab.url}
              key={tab.slug}
              target="_self"
              value={tab.slug}
              icon={
                tabIcons[tab.slug] ? (
                  <Icon icon={tabIcons[tab.slug].icon} prefix={tabIcons[tab.slug].prefix} />
                ) : undefined
              }
              label={<span className={classes.label}>{tab.label}</span>}
              {...addEvent({
                engagementComponent: 'navigation-bar',
                engagementDestination: getEngagementDestination(tab),
                engagementDetails: 'navigation-tab',
                name: 'engagement_navigation',
              })}
            />
          ))}
        </TabsRoot>
      </div>

      <div className={clsx(classes.fade, classes.fadeRight)} />
    </NavigationWrapper>
  )
}

export default Navigation
